// removed by extract-text-webpack-plugin
module.exports = {"slider":"_30ZoQsPuCYZ2RVTCxA9NYM","dots":"e3anN2qMSGaJkXCJ1QgwC","light":"c89LCVG692fmD-b5N9Bu0"};


//////////////////
// WEBPACK FOOTER
// ./src/v2SPRINTA/third-party/Slider/style.module.css
// module id = 422
// module chunks = 37